const whitelistAddresses = [
  "0xF14197dc4934B4D050c8cF64c24a469CB6e64BdA"
];

export default whitelistAddresses;
